export default "__VITE_ASSET__DwDc1Ym9__"